import React, { Component } from 'react';
import '../../App.css';

// images
import category1 from '../../img/section1.jpg'
import category2 from '../../img/section2.jpg'
import category3 from '../../img/section3.jpg'

class categories extends Component {
  render() {
    return (
      <div className="categories">
        <div id='category'>
            <img src={category1} alt=''/>
            <span>НАШЕ КОЧЕСТВО</span>
            <p><br/><br/>Наши продукты имеют сертификаты их качества также для экспорта, так и для употребления.</p>
        </div>
        <div id='category'>
            <img src={category2} alt=''/>
            <span>НАШИ ФЕРМЕРЫ</span>
            <p><br/><br/>Наши фермеры являются увлеченными и им интересно производить свежую и качественную пищу. Традиция, которая прошла из поколения в поколение</p>
        </div>
        <div id='category'>
            <img src={category3} alt=''/>
            <span>НАША ИННОВАЦИЯ И УСТОЙЧИВОСТЬ</span>
            <p>Pioricost имеет один из основных опор научных исследований, чтобы поставлять высокачественные продукты с экологической ответственностью нашим клиентам.</p>
        </div>
      </div>
    );
  }
}

export default categories;


// WEBPACK FOOTER //
// ./src/components/ru-home/categories.js